import SettingsAdjust20 from '@carbon/icons-react/es/settings--adjust/20';
import { Col, Row } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { AdvancedSettings } from 'components/organisms/module-settings/advanced-settings';
import { useTranslation } from 'hooks/use-translation';

const PageContent = styled(Page.Content)`
  padding: var(--layout-03);
`;

export const AdvancedSettingsPage = () => {
  const title = useTranslation('advanced_settings');

  return (
    <Page>
      <Page.Header
        $white
        title={
          <HeaderWithIconTitle icon={<SettingsAdjust20 />} title={title} />
        }
      />
      <PageContent>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Row>
          <Col xxl={20} sm={24}>
            <AdvancedSettings />
          </Col>
        </Row>
      </PageContent>
    </Page>
  );
};
